module.exports = __webpack_public_path__ + "img/slider_3.976c2ed5.webp";